<template>
  <div>
    <el-dialog
      title="报警信息"
      :visible.sync="dlgState"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="电梯报警" name="dtbj">
          <div
            style="display: flex;height: 80px;margin-bottom: 10px;margin-left: 30px;"
          >
            <!-- <img style="height: 74px;" src="../../../assets/imgs/jksl-bg.png" alt=""> -->
            <el-image
              style="height: 74px;"
              :src="infoData.imgUrl"
              :preview-src-list="imgUrlList"
              alt="暂无图片"
            ></el-image>
            <div class="ml10 mt10">
              <div
                style="width: 300px;font-size: 16px;font-weight: bolder;color: #E86452;"
              >
                <span>{{ infoData.event }}</span>
                <span style="float: right;">
                  <el-tag type="danger">{{ infoData.alarmLevelKey }}</el-tag>
                  <!-- <dict-tag
                style="font-size: 16px;color: #E86452;background-color: #fff;border: none;"
             
                :value="infoData.alarmLevelValue"
              /> -->
                </span>
              </div>
              <div style="width: 200px;margin-top: 10px;font-size: 14px;">
                <div style="width: 300px;">
                  <span class="mr10">时间: {{ infoData.createTime }}</span>
                  <span>人员: {{ infoData.personcount }}人</span>
                </div>
                <div style="width: 400px">
                  地点:
                  {{
                    infoData.buildingName +
                      "-" +
                      infoData.unitName +
                      "-" +
                      infoData.liftName
                  }}
                </div>
              </div>
            </div>
          </div>
          <el-form
            ref="formRef"
            :model="formData"
            :rules="formRules"
            label-width="100px"
            v-loading="formLoading"
          >
            <el-form-item label="报警原因" prop="alarmReasonValue">
              <el-select
                :disabled="!isInfo"
                v-model="formData.alarmReasonValue"
                filterable
                clearable
                placeholder="请选择报警原因"
              >
                <el-option
                  v-for="item in alarmReasonList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="处理方式" prop="handleWayValue">
              <el-select
                :disabled="!isInfo"
                v-model="formData.handleWayValue"
                filterable
                clearable
                placeholder="请选择处理方式"
              >
                <el-option
                  v-for="item in processTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="处理时间" prop="handleTime">
              <el-date-picker
                :disabled="!isInfo"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="formData.handleTime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                :disabled="!isInfo"
                v-model="formData.remark"
                placeholder="请输入备注"
                type="textarea"
                resize="none"
              />
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="报事信息" name="bsxx" v-if="isBaoshi">
          <div class="bpmn-body">
            <div class="dflex">
              <el-form
                ref="dia2Form"
                label-width="110px"
                class="dia-left"
                style="padding-left: 0"
                :model="dia2Data"
              >
                <!-- 12 报事登记 登记处理 -->

                <div class="dia-left-item" style="margin-top: 24px">
                  <div class="dia-bar-title">报事登记</div>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="单号">
                        {{
                          dia2Data.id == "" ? "系统自动生成" : dia2Data.orderNo
                        }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="项目" prop="projectId">
                        {{ dia2Data.projectName }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        v-if="dia2Data.buildingName"
                        label="楼栋信息"
                        prop="buildingName"
                      >
                        <span>{{ dia2Data.buildingName }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="dia2Data.address" :span="12">
                      <el-form-item label="详细地址" prop="address">
                        <span>{{ dia2Data.address }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="点位" prop="areaName">
                        <span>{{ dia2Data.areaName }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="科目" prop="subjectName">
                        <span>{{ dia2Data.subjectName }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="内容描述" prop="content">
                    <span>{{ dia2Data.content }}</span>
                  </el-form-item>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="报事人" prop="orderUserName">
                        <span>{{ dia2Data.orderUserName }}</span>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                      <el-form-item label="报事人科室" prop="departmentName">
                        <span>{{ dia2Data.departmentName }}</span>
                      </el-form-item>
                    </el-col> -->
                    <el-col :span="12">
                      <el-form-item label="报事人电话" prop="orderUserPhone">
                        <span>{{ dia2Data.orderUserPhone }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="12">
                      <el-form-item label="报事接单人" prop="orderUserPhone">
                        <span>{{ dia2Data.orderExecutorName }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="接单模式" prop="modelTypeText">
                        <span>{{ dia2Data.modelTypeText }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="报事执行人岗位"
                        prop="orderUserPhone"
                      >
                        <span>{{ dia2Data.orderExecutorPostName }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="来源">
                        {{ dia2Data.orderSource }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="紧急度" prop="urgency">
                        <span>{{ dia2Data.urgencyText }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="是否预约" prop="isArrival">
                        <span>{{ dia2Data.isArrival == 1 ? "是" : "否" }}</span>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="类型" prop="userType">
                        <span v-if="dia2Data.userType == 'LXERP'">维舟云ERP</span>
                        <span v-else-if="dia2Data.userType == 'JYTUSER'"
                          >简E通</span
                        >
                        <span v-else></span>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12" v-if="dia2Data.isArrival == 1">
                      <el-form-item label="预约到达时间" prop="arrivalTime">
                        <span>{{ dia2Data.arrivalTime }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <!-- 3 报事审核 -->
                <div v-if="dia2Data.auditResultText" class="dia-left-item">
                  <div class="dia-bar-title">报事审核</div>
                  <el-form-item label="审核结果">
                    <span>{{ dia2Data.auditResultText }}</span>
                  </el-form-item>

                  <el-form-item label="审核意见">
                    <span>{{ dia2Data.auditContent }}</span>
                  </el-form-item>
                  <el-row v-if="dia2Data.auditName">
                    <el-col :span="12">
                      <el-form-item label="审核人">
                        {{ dia2Data.auditName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="审核时间">
                        {{ dia2Data.auditTime }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 4 报事派工 -->
                <div v-if="dia2Data.usersInfoNames" class="dia-left-item">
                  <div class="dia-bar-title">报事派工</div>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="接单人">
                        <span>{{ dia2Data.usersInfoNames }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="dia2Data.dispatchName">
                    <el-col :span="12">
                      <el-form-item label="派工人">
                        {{ dia2Data.dispatchName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="派工时间">
                        {{ dia2Data.dispatchTime }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 接单确认 -->
                <div v-if="dia2Data.confirmOrderUserName" class="dia-left-item">
                  <div class="dia-bar-title">接单确认</div>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="确认人">
                        {{ dia2Data.confirmOrderUserName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="确认时间">
                        {{ dia2Data.confirmOrderTime }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 报事到达 -->
                <div v-if="dia2Data.arriveUserName" class="dia-left-item">
                  <div class="dia-bar-title">报事到达</div>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="到达人">
                        {{ dia2Data.arriveUserName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="到达时间">
                        {{ dia2Data.arriveTime }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 报事回单 -->
                <div v-if="dia2Data.archiver" class="dia-left-item">
                  <div class="dia-bar-title">报事回单</div>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="回单人">
                        {{ dia2Data.confirmOrderUserName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="回单时间">
                        {{ dia2Data.archiveTime.slice(0, -3) }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="回单内容">
                    {{ dia2Data.archiveContent }}
                  </el-form-item>
                  <el-form-item
                    v-if="dia2Data.archiveUrl && dia2Data.archiveUrl.length > 0"
                    label="回单照片"
                  >
                    <el-image
                      class="archiveUrl"
                      v-for="(item, index) of dia2Data.archiveUrl"
                      :key="index"
                      :src="item"
                      :preview-src-list="[item]"
                    ></el-image>
                  </el-form-item>
                </div>
                <!-- 5 << 报事回访 -->
                <div v-if="dia2Data.returnVisitText" class="dia-left-item">
                  <div class="dia-bar-title">报事回访</div>
                  <el-form-item label="回访方式">
                    <span>{{ dia2Data.returnVisitText }}</span>
                  </el-form-item>

                  <div v-if="dia2Data.returnVisit != 3">
                    <el-form-item label="满意度">
                      <span>{{ dia2Data.isSatisfiedText }}</span>
                    </el-form-item>

                    <el-form-item label="回访记录">
                      <span>{{ dia2Data.returnRemark }}</span>
                    </el-form-item>
                  </div>
                  <el-row v-if="dia2Data.returnUser">
                    <el-col :span="12">
                      <el-form-item label="回访人">
                        {{ dia2Data.returnUser }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="回访时间">
                        {{ dia2Data.returnTime }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <!-- 6 报事归档 -->
                <div v-if="dia2Data.archiveOrderUser" class="dia-left-item">
                  <div class="dia-bar-title">报事归档</div>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="归档人">
                        {{ dia2Data.archiveOrderUser }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="归档时间">
                        {{ dia2Data.archiveOrderTime }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 7无改派 -->
                <!-- 8 跟进 -->
                <div v-if="dia2Data.followWayText" class="dia-left-item">
                  <div class="dia-bar-title">跟进</div>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="跟进方式">
                        <span>{{ dia2Data.followWayText }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="未完成原因">
                        <span>{{ dia2Data.undoneReasonText }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="跟进备注">
                    <span>{{ dia2Data.remark }}</span>
                  </el-form-item>
                  <el-form-item label="预约完成时间">
                    <span>{{ dia2Data.expectedTime }}</span>
                  </el-form-item>
                </div>
                <!-- 9 关注 -->
                <div v-if="dia2Data.attentionName" class="dia-left-item">
                  <div class="dia-bar-title">关注</div>
                  <!-- {{dia2Data.gzUserInfosNames}} -->
                  <el-form-item label="关注人">
                    <span>{{ dia2Data.attentionName }}</span>
                  </el-form-item>
                </div>
                <!-- 作废 -->
                <div v-if="dia2Data.invalidReasonText" class="dia-left-item">
                  <div class="dia-bar-title">
                    {{ dia2Data.status == "8" ? "作废信息" : "流转信息" }}
                  </div>
                  <!-- {{dia2Data.gzUserInfosNames}} -->
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        :label="
                          dia2Data.status == '8' ? '作废原因' : '流转原因'
                        "
                      >
                        {{ dia2Data.invalidReasonText }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        :label="
                          dia2Data.status == '8' ? '作废备注' : '流转备注'
                        "
                      >
                        {{ dia2Data.invalidRemark }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 暂缓 -->
                <div
                  v-if="
                    dia2Data.orderSuspendMaintenanceLogs &&
                      dia2Data.orderSuspendMaintenanceLogs.length > 0
                  "
                  class="dia-left-item"
                >
                  <div class="dia-bar-title">暂缓原因</div>

                  <el-row
                    v-for="(item,
                    index) in dia2Data.orderSuspendMaintenanceLogs"
                    :key="index"
                  >
                    <el-col :span="12">
                      <el-form-item label="时间">
                        {{ item.createTime }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="理由">
                        {{ item.cause }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 物料 -->
                <div
                  v-if="
                    dia2Data.materialDetails &&
                      dia2Data.materialDetails.length > 0
                  "
                  class="dia-left-item"
                >
                  <div class="dia-bar-title">物料信息</div>

                  <el-row
                    v-for="(item, index) in dia2Data.materialDetails"
                    :key="index"
                  >
                    <el-col :span="8">
                      <el-form-item label="物料名称">
                        {{ item.name }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="物料规格">
                        {{ item.model }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="物料数量">
                        {{ item.num }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
              <div class="dia-right flex1">
                <div class="">
                  <div class="dia-right-title">附件</div>
                  <div class="mt10">
                    <div
                      v-for="(item, index) of dia2Data.otherFiles"
                      :key="index"
                    >
                      <div
                        v-if="item.type == 'wav'"
                        style="margin-top: 4px; margin-bottom: 4px"
                      >
                        <div class="fl" style="line-height: 36px">语音：</div>
                        <audio
                          controls
                          class="fl"
                          style="width: 280px; height: 36px"
                          :id="`audio-${index}`"
                          :src="item.url"
                        ></audio>
                        <!-- <div class="fl dia-fj-name elli" :title="item.name">{{item.name}}</div> -->
                        <!-- <div class="fr m-a" @click="playAudio(index)">播放</div> -->
                        <div class="clear"></div>
                      </div>
                      <div v-else>
                        <div class="fl">图片：</div>
                        <div class="fl dia-fj-name elli" :title="item.name">
                          {{ item.name }}
                        </div>
                        <el-image
                          :id="`dia-fj-${index}`"
                          style="width: 0px; height: 0px"
                          :preview-src-list="[item.url]"
                          :src="item.url"
                          alt=""
                        ></el-image>
                        <div @click="showBigImg(index)" class="fr m-a">
                          查看
                        </div>
                        <div class="clear"></div>
                      </div>
                    </div>
                  </div>
                  <el-upload action="" :show-file-list="false">
                    <!-- <el-button
                      v-if="dia2TypeIndex == 1"
                      class="mt10"
                      icon="el-icon-plus"
                      type="primary"
                      >选择本地文件</el-button
                    > -->
                  </el-upload>
                </div>
                <div class="mt40" v-if="dia2Data.orderFollowupList.length > 0">
                  <div class="dia-right-title">跟进</div>

                  <div
                    v-for="(item, index) of dia2Data.orderFollowupList"
                    :key="index"
                    class="mt20"
                  >
                    <div class="fbold">第 {{ index + 1 }} 次跟进</div>
                    <div>跟进方式：{{ item.followWayText }}</div>
                    <div>跟进人：{{ item.createUser }}</div>
                    <div>跟进时间：{{ item.createTime }}</div>
                    <div>未完成原因：{{ item.undoneReasonText }}</div>
                    <div>跟进备注：{{ item.remark }}</div>
                    <div>预计完成时间：{{ item.expectedTime }}</div>
                  </div>
                </div>
                <div class="mt40" v-if="dia2Data.attentionName">
                  <div class="dia-right-title">关注</div>

                  <div class="mt20">
                    <div>关注人：{{ dia2Data.attentionName }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="submitForm"
          type="primary"
          :disabled="formLoading"
          v-if="isInfo"
          icon="el-icon-check"
          >确 定</el-button
        >
        <el-button @click="closeDlg('fanhui')" icon="el-icon-back"
          >返回</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { postAction, getAction } from "@/api";
// 接口
import { alarmInfo, alarmHandle } from "@/api/leftMan";
import * as utils from "@/utils";
import dayjs from "dayjs";
import {
  arrId2Name, // 根据id 获取name
  getDataDictOther // 数据字典
} from "@/utils";
let formDataEmpty = {
  id: "",
  alarmReasonKey: "", //	报警原因key
  alarmReasonValue: "", //	报警原因value
  handleWayKey: "", //	处理方式key
  handleWayValue: "", //	处理方式value
  handleTime: "", //	处理时间
  handleUserId: "", //	处理人ID
  handleUserName: "",
  remark: ""
};
//报事
let dia2DataEmpty = {
  id: "",
  projectId: "", // 项目id
  projectName: "", // 项目名称
  areaId: "", // 报事区域id
  areaName: "", // 报事区域名称
  subjectId: "", // 报事科目id
  subjectName: "", // 报事科目名称
  content: "", // 报事内容
  orderUserName: "", // 报事人姓名
  orderUserId: "0", // 报事人id
  orderExecutorName: [], //报事接单人
  orderExecutorId: [],
  orderUserPhone: "", // 报事人电话
  urgency: "", // 紧急度
  urgencyText: "", // 紧急度
  isArrival: 1, // 是否预约  0 不预约   1 预约
  userType: "JYTUSER", // LXERP-维舟云ERP  JYTUSER-简E通
  modelType: "",
  modelTypeText: "", //接单模式  1:共同执行 2:竞争执行
  arrivalTime: "", // 预约到达时间
  otherFiles: [], // 附件信息地址 arr
  status: "2", // 0:已登记 1:已审核 2:已派工 3:已确认 4：已到达 5：已回单 6：已回访 7：已归档 8：已作废
  orderSource: "", // 报事来源
  orderFollowupList: [],
  orderExecutorPostName: "", // 报事执行人岗位名称
  orderExecutorPostId: "",
  alarmId: "" //报警id
};
export default {
  props: {
    dlgState0: {
      type: Boolean,
      default: false
    },
    dlgQuery: {
      type: Object,
      default: {}
    },
    dlgType: {
      type: String,
      default: ""
    }
  },
  watch: {
    dlgState0(val) {
      console.log(val, "val");
      this.dlgState = val;
    },
    dlgState(val) {
      this.$nextTick(() => {
        this.$refs["formRef"].clearValidate();
      });
      this.formData = JSON.parse(JSON.stringify(formDataEmpty));
      this.activeName = "dtbj";
      if (val) {
        this.isBaoshi = false;
        this.getInfo();
        console.log(this.dlgQuery, "this.dlgQuery");

        if (this.dlgQuery.orderId) {
          this.isBaoshi = true;
          this.getBaoShiInfo();
        }
      } else {
        this.$emit("closeDlg");
      }
    }
  },
  data() {
    return {
      dlgState: false,
      formLoading: false,
      isInfo: true,
      userInfo: JSON.parse(window.localStorage.userInfo),
      formData: JSON.parse(JSON.stringify(formDataEmpty)), // 初始化数据
      formRules: {
        alarmReasonValue: [
          { required: true, message: "请选择报警原因", trigger: "change" }
        ],
        handleWayValue: [
          { required: true, message: "请选择处理方式", trigger: "change" }
        ],
        handleTime: [
          { required: true, message: "请选择处理时间", trigger: "change" }
        ]
      },
      imgUrlList: [],
      infoData: {},
      processTypeList: [],
      alarmReasonList: [],

      activeName: "dtbj",
      //是否报事
      isBaoshi: false,
      dia2Data: JSON.parse(JSON.stringify(dia2DataEmpty))
    };
  },
  created() {
    getDataDictOther(this, "processType", "processTypeList"); // 处理方式
    getDataDictOther(this, "alarmReason", "alarmReasonList"); // 报警原因
  },
  methods: {
    getInfo() {
      alarmInfo(this.dlgQuery.id).then(res1 => {
        let res = res1.data;
        if (res.code == 200) {
          // if (!utils.isNull(res.data.imgUrl)) {
          //   res.data.imgUrl = res.data.imgUrl
          //     .slice(0, 0)
          //     .concat("http://", res.data.imgUrl);
          // }
          this.imgUrlList = [res.data.imgUrl];
          res.data.createTime = res.data.createTime;
          this.infoData = res.data;
          if (this.dlgType == "info") {
            this.formData.handleTime = res.data.handleTime;
            this.formData.handleWayValue = res.data.handleWayValue;
            this.formData.handleWayKey = res.data.handleWayKey;
            this.formData.alarmReasonValue = res.data.alarmReasonValue;
            this.formData.alarmReasonKey = res.data.alarmReasonKey;
            this.formData.remark = res.data.remark;
            this.isInfo = false;
            console.log(this.formData, "this.formData");
          } else {
            this.isInfo = true;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    getBaoShiInfo() {
      getAction(
        `/report/order/findOrderById/${this.dlgQuery.orderId}`,
        {}
      ).then(res0 => {
        let res = res0.data;
        if (res.code == 200) {
          let dia2Data = JSON.parse(JSON.stringify(res.data));
          let otherFiles = dia2Data.otherFiles.split(",");
          let otherFilesNew = [];
          for (let item of otherFiles) {
            if (item) otherFilesNew.push(this.imgUrl2Obj(item));
          }
          if (otherFilesNew[0] == "") otherFilesNew = [];
          dia2Data.otherFiles = otherFilesNew;

          if (!dia2Data.usersInfo) {
            dia2Data.usersInfo = [];
          }
          // 改派
          if (dia2Data.takerNames) {
            dia2Data.modelTypeText = dia2Data.modelTypeText;
            dia2Data.usersInfoNames = dia2Data.takerNames;
          }

          dia2Data.modelType1 = dia2Data.modelTypeText1 = "";
          dia2Data.usersInfo1 = [];
          dia2Data.usersInfoNames1 = "";
          if (dia2Data.orderFollowupList == null) {
            dia2Data.orderFollowupList = [];
          }

          if (dia2Data.archiveUrl && dia2Data.archiveUrl !== "null") {
            dia2Data.archiveUrl = dia2Data.archiveUrl.split(",");
          } else {
            dia2Data.archiveUrl = "";
          }

          // >> 有数据

          this.dia2Data = JSON.parse(JSON.stringify(dia2Data));
          console.log(this.dia2Data, "this.dia2Data ");
          this.$nextTick(() => {
            this.$refs["dia2Form"].clearValidate();
          });
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    imgUrl2Obj(url) {
      let name = url.split("/");
      name = name[name.length - 1];
      let type = name.split(".")[1];
      if (type != "wav") type = "image";
      let obj = {
        type,
        url,
        name
      };
      return obj;
    },
    // 查看图片
    showBigImg(index) {
      $(`#dia-fj-${index}`).click();
    },
    // 播放语音
    playAudio(index) {
      let audioElement = document.getElementById(`audio-${index}`);
      audioElement.pause();
      setTimeout(() => {
        audioElement.play();
      }, 100);
    },
    submitForm() {
      this.$refs["formRef"].validate(valid => {
        if (valid) {
          let sendObj = JSON.parse(JSON.stringify(this.formData));
          if (
            new Date(sendObj.handleTime).getTime() <
            new Date(this.infoData.createTime).getTime()
          ) {
            this.$message.error("处理时间不能小于报警时间");
            return;
          }
          if (new Date(sendObj.handleTime).getTime() > new Date().getTime()) {
            this.$message.error("处理时间不能大于当前时间");
            return;
          }
          sendObj.id = this.dlgQuery.id;
          sendObj.handleUserId = this.userInfo["id"];
          sendObj.handleUserName = this.userInfo["label"];
          sendObj.handleWayKey = arrId2Name(
            this.processTypeList,
            sendObj.handleWayValue
          );
          sendObj.alarmReasonKey = arrId2Name(
            this.alarmReasonList,
            sendObj.alarmReasonValue
          );
          this.formLoading = true;
          alarmHandle(sendObj).then(res1 => {
            let res = res1.data;
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "操作成功"
              });

              this.closeDlg("chuli");
            } else {
              this.$message({
                type: "warning",
                message: res.msg
              });
            }
            this.formLoading = false;
          });
        }
      });
    },
    closeDlg(type) {
      this.$emit("closeDlg", type);
    }
  }
};
</script>
